import React, { memo, useContext } from 'react'
import { ProductsMinor } from '@shopify/polaris-icons'
import { PaymentsTableContext } from '../payments-table/PaymentsTable.context'
import { PaymentStatus } from 'src/constants/payment/enums'
import { PaymentStatusChip } from './PaymentStatusChip'
import { TableSelect } from 'src/components/shared/table/TableSelect'

const statuses = [
  {
    value: PaymentStatus.Paid,
    component: <PaymentStatusChip status={PaymentStatus.Paid} />,
  },
  {
    value: PaymentStatus.NotPaid,
    component: <PaymentStatusChip status={PaymentStatus.NotPaid} />,
  },
  {
    value: PaymentStatus.RolledUpToMaster,
    component: <PaymentStatusChip status={PaymentStatus.RolledUpToMaster} />,
  },
  {
    value: PaymentStatus.Pending,
    component: <PaymentStatusChip status={PaymentStatus.Pending} />,
  },
  {
    value: PaymentStatus.AutoRetry,
    component: <PaymentStatusChip status={PaymentStatus.AutoRetry} />,
  },
  {
    value: PaymentStatus.Failed,
    component: <PaymentStatusChip status={PaymentStatus.Failed} />,
  },
  {
    value: PaymentStatus.RequiresFunding,
    component: <PaymentStatusChip status={PaymentStatus.RequiresFunding} />,
  },
  {
    value: PaymentStatus.WaitingForFunding,
    component: <PaymentStatusChip status={PaymentStatus.WaitingForFunding} />,
  },
  {
    value: PaymentStatus.Voided,
    component: <PaymentStatusChip status={PaymentStatus.Voided} />,
  },
]

const PaymentStatusSelectComponent = () => {
  const { statusFilter, setStatusFilter } = useContext(PaymentsTableContext)

  return (
    <TableSelect<PaymentStatus>
      title="Settlement Status"
      selectedValues={statusFilter}
      icon={<ProductsMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
      triggerDataTestId="payments-main-status-menu-btn"
      clearAllDataTestId="payments-main-status-clear-all"
    />
  )
}

export const PaymentStatusSelect = memo(PaymentStatusSelectComponent)
